<div class="d-flex flex-column">
    <div class="d-flex card flex-column">
        <p-editor *ngIf="customerNoteSelected" [(ngModel)]="customerNoteSelected.body" name="logBody" id="logBody"
            styleClass="w-100 my-4 mx-2">
            <p-header>
                <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                </span>
            </p-header>
        </p-editor>
        <div class="d-flex justify-content-end">
            <p-button pRipple styleClass="p-button-raised my-2 ms-auto" (click)="notePost()">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","save"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
        </div>
        
    </div>
    <div>
        <p-timeline [value]="customerNoteList" align="alternate" styleClass="w-100" styleClass="customized-timeline">
            <ng-template pTemplate="marker" let-event>
                <span class="custom-marker p-shadow-2">
                    <fa-icon [icon]='["far","sticky-note"]'></fa-icon>
                </span>
            </ng-template>
            <ng-template pTemplate="content" let-rec>
                <p-card styleClass="my-2">
                    <ng-template pTemplate="header">
                        <div class="d-flex">
                            <div class="h4 m-2">{{moment(rec.created).format('l LT')}} by {{rec.authorUser?.firstName}} {{rec.authorUser?.lastName}}</div>
                            <div class="ms-auto">
                                <fa-icon *ngIf="user.role > 1" [icon]='["far","trash"]' (click)="noteDelete(rec)" class="mx-2"></fa-icon>
                            </div>
                        </div>
                    </ng-template>
                    <div [innerHTML]="rec.body"></div>

                </p-card>
            </ng-template>
        </p-timeline>
    </div>
</div>